import { UserFacingError } from '@monetize/types/app';
import { parseTemplateExpression } from './template-expression-parser';
import {
  createTemplateExpressionRegex,
  decodeTemplateExpressionEntities,
} from './template-expression-parser.utils';

export interface TemplateExpressionValidationError {
  /** The offending expression, entity-decoded, including the curly braces */
  expression: string;
  error: string;
}

/**
 * Validate every `{{...}}` template expression in a piece of (rich text)
 * content, using the same extraction and entity decoding as evaluation.
 * Returns one entry per invalid expression, in document order; an empty
 * array means all expressions parsed.
 *
 * Note this is syntax validation only — it does not verify that referenced
 * fields exist on any particular record.
 */
export function validateTemplateExpressions(
  content: string,
): TemplateExpressionValidationError[] {
  const errors: TemplateExpressionValidationError[] = [];
  if (!content || !content.includes('{{')) {
    return errors;
  }
  for (const match of content.matchAll(createTemplateExpressionRegex())) {
    const expression = decodeTemplateExpressionEntities(match[0].trim());
    try {
      parseTemplateExpression(expression);
    } catch (ex) {
      errors.push({
        expression,
        error:
          ex instanceof UserFacingError ? ex.message : 'Invalid expression',
      });
    }
  }
  return errors;
}
